"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeSubmit = void 0;
var FakeSubmit = function (form) {
    if (!form)
        return;
    var element = document.createElement('button');
    element.classList.add('button', 'button--default');
    form.appendChild(element);
    element.click();
    element.remove();
};
exports.FakeSubmit = FakeSubmit;
// const FakeSubmit = {
//   init(form: HTMLFormElement) {
//     if (!form) return
//     const element = document.createElement('button') as HTMLButtonElement
//     element.classList.add('button', 'button--default')
//     form.appendChild(element)
//     element.click()
//     element.remove()
//   },
// }
// export default FakeSubmit
//# sourceMappingURL=index.js.map